(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/email/components/email-save.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/email/components/email-save.js');
'use strict';

const {
  useState
} = React;
const Button = svs.ui.ReactButton;
const EmailInput = svs.ui.reactFormInputs.EmailInput;
const {
  Form
} = svs.ui.reactForm;
const {
  emailStatuses
} = svs.myProfile.constants;
const {
  saveEmail
} = svs.myProfile.react.store.pdPreferences.actions;
const {
  getCustomersPreferences,
  setForceSaveEmail
} = svs.myProfile.react.store.pdPreferences.actions;
const {
  getMessageByCode
} = svs.myProfile.react.shared.errorMessages;
const {
  showSuccessDialog,
  showErrorDialog
} = svs.myProfile.react.pages.myInformation.myInformation.emailDialogs;

const EmailSave = () => {
  const dispatch = ReactRedux.useDispatch();
  const {
    emailStatus,
    email
  } = ReactRedux.useSelector(state => state.playerPreferences.playerPreferences);
  const emailBounced = emailStatus === emailStatuses.BOUNCE;
  const [newEmail, setNewEmail] = useState('');
  React.useEffect(() => {
    dispatch(getCustomersPreferences());
  }, [dispatch]);
  const trackEvent = saved => {
    const track = {
      category: 'My Profile',
      action: emailBounced ? 'email add' : 'email update',
      opt_label: saved ? 'Yes' : 'No'
    };
    svs.components.analytics.trackEvent(track);
  };
  const onSubmitHandler = async (e, formData, isValid) => {
    e.preventDefault();
    if (isValid) {
      const result = await dispatch(saveEmail(newEmail));
      if (RTK.isFulfilled(result)) {
        trackEvent(true);
        showSuccessDialog(newEmail);
        dispatch(setForceSaveEmail(false));
      } else {
        var _result$payload;
        const errorCode = result === null || result === void 0 || (_result$payload = result.payload) === null || _result$payload === void 0 ? void 0 : _result$payload.error;
        showErrorDialog(getMessageByCode(errorCode) || 'Någonting gick fel när epostadressen skulle sparas. Försök igen eller kontakta kundservice.');
      }
    }
  };
  return React.createElement(Form, {
    onSubmit: onSubmitHandler
  }, React.createElement("div", {
    className: "f-left relative"
  }, React.createElement(EmailInput, {
    isLessSpace: true,
    label: email ? 'Ange ny e-post' : 'Ange e-post',
    name: "email",
    onChange: e => setNewEmail(e.target.value),
    value: newEmail
  }), React.createElement(Button, {
    block: true,
    className: "margin-v-1",
    inverted: true,
    size: 300,
    type: "submit"
  }, "Spara")));
};
svs.myProfile.react.pages.myInformation.myInformation.email.EmailSave = EmailSave;

 })(window);